// import { takeLatest } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';

import { nopSaga } from './nopSaga';
import { remoteSaga } from './remoteSaga';

// import * as types from '../constants/actionTypes';

export function* watchNOP() {
  // yield takeLatest(types.NOP, nopSaga);
  yield takeLatest('NOP', nopSaga);
}

export function* watchRemoteSaga() {
  yield takeLatest('REMOTE_ACTION', remoteSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/watchers.js